export function normalizePersonName(value) {
    return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('nl')
        .replace(/\s+/g, ' ')
        .trim();
}

export function parseNameFilters(value) {
    const values = Array.isArray(value) ? value : String(value || '').split(/[,;\n]+/);
    const seen = new Set();

    return values.reduce((filters, entry) => {
        const label = String(entry || '').replace(/\s+/g, ' ').trim();
        const key = normalizePersonName(label);
        if (!key || seen.has(key)) return filters;
        seen.add(key);
        filters.push(label);
        return filters;
    }, []);
}

function nodeNameFields(node) {
    return [node?.label, node?.firstname, node?.lastname]
        .map(normalizePersonName)
        .filter(Boolean);
}

function findMatchesForFilter(nodes, normalizedFilter) {
    const searchable = nodes.map(node => ({ node, fields: nodeNameFields(node) }));
    const exactMatches = searchable
        .filter(({ fields }) => fields.some(field => field === normalizedFilter))
        .map(({ node }) => node);

    if (exactMatches.length) return exactMatches;
    return searchable
        .filter(({ fields }) => fields.some(field => field.includes(normalizedFilter)))
        .map(({ node }) => node);
}

export function buildPersonNameFilterResult({ nodes = [], links = [], filters = [] } = {}) {
    const parsedFilters = parseNameFilters(filters);
    if (!parsedFilters.length) {
        return {
            filters: [],
            matchedIds: new Set(),
            visibleIds: null,
            matchesByFilter: new Map(),
        };
    }

    const matchedIds = new Set();
    const matchesByFilter = new Map();
    for (const filter of parsedFilters) {
        const key = normalizePersonName(filter);
        const matches = findMatchesForFilter(nodes, key);
        const matchIds = new Set(matches.map(node => node.id).filter(Boolean));
        matchesByFilter.set(key, matchIds);
        matchIds.forEach(id => matchedIds.add(id));
    }

    const visibleIds = new Set(matchedIds);
    for (const link of links) {
        const sourceId = link?.source?.id || link?.source;
        const targetId = link?.target?.id || link?.target;
        if (matchedIds.has(sourceId)) visibleIds.add(targetId);
        if (matchedIds.has(targetId)) visibleIds.add(sourceId);
    }

    return {
        filters: parsedFilters,
        matchedIds,
        visibleIds,
        matchesByFilter,
    };
}
